export enum TrainingRequestState {
  Pending,
  Approved,
  Rejected,
}
